import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6.983 19H4V18H5.989V17.5H4.995V16.5H5.99V16H4V15H6.983V19ZM21 18H9.069V16H21V18ZM6.983 14H4V13.1L5.79 11H4V10H6.983V10.9L5.193 13H6.983V14ZM21 13H9.069V11H21V13ZM6.486 9H5.491V6H4.5V5H6.486V9ZM21 8H9.069V6H21V8Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ListOl"
);
